import { TrendingProductResponseDto } from '../dto/trendingproducts.dto';
import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';

class TrendingProductService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getTrendingProducts(): Promise<TrendingProductResponseDto> {
    return this.__Apiservice.getRequest('products/trending', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

// Create an instance of the service
const trendingProductService = new TrendingProductService();

export default trendingProductService;